import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  inject,
  Injector,
  signal,
} from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { Subscription } from 'rxjs';
import { AutofocusDirective } from '../../directives/sia-autofocus.directive';
@Component({
  selector: 'dialog-overview-example-dialog',
  templateUrl: `yes-no-dialog.html`,
  styleUrls: ['yes-no-dialog.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AutofocusDirective,
    MatDialogContent,
    MatDialogActions,
    MatDialogTitle,
    MatDialogClose,
    MatIconButton,
    MatButton,
    MatIcon,
  ],
})
export class YesNoDialogComponent {
  #dialogRef = inject<MatDialogRef<YesNoDialogComponent>>(MatDialogRef);
  #injector = inject(Injector);
  readonly data = signal(inject(MAT_DIALOG_DATA));

  get dialogTitle(): string {
    return this.data().dialogTitle ?? 'Conferma operazione';
  }
  get yesLabel(): string {
    return this.data().yesLabel ?? 'Sì, conferma';
  }
  get noLabel(): string {
    return this.data().noLabel ?? 'No, continua';
  }

  #subs: Subscription[] = [];

  pageDataSetted: boolean = false;

  constructor() {
    this.#dialogRef.updateSize('min(95% , 600px)');
  }

  onNoClick() {
    this.#dialogRef.close(false);
  }
  onYesClick() {
    // this.data.result = true;
    this.#dialogRef.close(true);
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (this.data().disableKeyboardShortcut) {
      return;
    }
    if (event.key === 'S' || event.key === 's') {
      this.onYesClick();
    } else if (event.key === 'N' || event.key === 'n') {
      this.onNoClick();
    }
  }

  ngOnDestroy() {
    this.#subs.forEach((s) => s.unsubscribe());
  }
}
